import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TableOfContents',
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const viewButtonText = computed(() => props.block.fields.ViewButtonText || "");
const hideButtonText = computed(() => props.block.fields.HideButtonText || "");

function hideTOC(tocButton, hide) {
  let tocButtonTextOutput = "";

  if (tocButton.classList.contains("toc-visible") || hide == false) {
    tocButton.classList.remove("toc-visible");
    tocButtonTextOutput = hideButtonText.value;
  } else {
    tocButton.classList.add("toc-visible");
    tocButtonTextOutput = viewButtonText.value;
  }
  const tocButtonText = tocButton.getElementsByClassName("text")[0];
  if (tocButtonText) {
    tocButtonText.innerHTML = tocButtonTextOutput;
  }
}

function isTopInViewport(el) {
  const topMargin = 120;
  if (el) {
    const rect = el.getBoundingClientRect();
    return rect.top <= topMargin;
  }
  return false;
}

function updateTargets(targets) {
  targets.forEach((target) => {
    const targetId = target.getAttribute("href").substring(1);
    const targetToWatch = document.getElementById(targetId);
    const anchor = document.querySelector(`a[href^="#${targetId}"]`);
    const isVisble = isTopInViewport(targetToWatch);

    if (isVisble) {
      const anchorSelected = document.querySelector(".toc .selected");
      if (anchorSelected) {
        anchorSelected.classList.remove("selected");
      }

      const anchorClicked = document.querySelector(".toc .click");
      if (anchorClicked && anchorSelected) {
        anchorSelected.classList.remove("click");
      }

      if (anchor) {
        anchor.classList.add("active", "selected");
      }
    } else {
      if (anchor) {
        anchor.classList.remove("active", "selected");
      }
    }
  });
}

onMounted(() => {
  const html = document.querySelector("html");
  const tocButton = document.getElementById("toc-button");

  document.addEventListener("keyup", (e) => {
    if (e.key === "Escape") {
      html.classList.toggle("esc");
      hideTOC(tocButton, true);
    }
  });

  if (tocButton) {
    tocButton.addEventListener("click", () => {
      hideTOC(tocButton, true);
    });
    hideTOC(tocButton, false);
  }

  const anchors = document.querySelectorAll('a[href^="#"]');
  const targets = [];

  anchors.forEach((anchor) => {
    anchor.setAttribute("draggable", false);
    anchor.addEventListener("click", (event) => {
      event.preventDefault();

      const anchorClicked = document.querySelector(".toc .click");
      if (anchorClicked) {
        anchorClicked.classList.remove("click");
      }
      anchor.classList.add("click");

      const target = anchor.getAttribute("href").substring(1);
      if (target) {
        const element = document.getElementById(target);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    });

    targets.push(anchor);
  });

  document.addEventListener(
    "scroll",
    () => {
      updateTargets(targets);
    },
    {
      passive: true,
    }
  );

  updateTargets(targets);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})